var map = {
	"./black/zhuanjie.png": "kRU9",
	"./blue/zhuanjie.png": "SC3D",
	"./white/zhuanjie.png": "xeC+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ubxu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/zhuanjie\.png$
// module id = ubxu
// module chunks = 24